import { useRef } from 'react'

export const Z_INDEX = {
    GUIDE: 1200,
    HIGHLIGHT: 1400,
    HIGHLIGHT_CUTOUT: 1402,
    HIGHLIGHT_ICON: 1403,
    TOUR_FLOW: 1500,
} as const

/**
 * Wait for a DOM element matching a selector to appear (polling-based).
 * Returns the element if found within the timeout, or null.
 */
export const waitForSelector = (selector: string, timeout = 3000): Promise<Element | null> =>
    new Promise(resolve => {
        const el = document.querySelector(selector)
        if (el) return resolve(el)
        const start = Date.now()
        const interval = setInterval(() => {
            const found = document.querySelector(selector)
            if (found || Date.now() - start > timeout) {
                clearInterval(interval)
                resolve(found)
            }
        }, 200)
    })

/** Ref that always holds the latest value — avoids stale closures in callbacks. */
export function useLatestRef<T>(value: T) {
    const ref = useRef(value)
    ref.current = value
    return ref
}
